document.addEventListener('DOMContentLoaded', ()=>{
    const prevBtn = document.querySelector('.trust-bar__nav--prev');
    const nextBtn = document.querySelector('.trust-bar__nav--next');
    const carousel = document.querySelector('.trust-bar__inner');
  
    if (!carousel) return;
  
    prevBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: -100, behavior: "smooth" });
    });
  
    nextBtn?.addEventListener("click", () => {
      carousel.scrollBy({ left: 100, behavior: "smooth" });
    });
})